import styled, { css } from 'styled-components';

export const Container = styled.div<{ imagePosition: 'right' | 'left' }>`
  display: flex;
  align-items: flex-start;
  padding: 2rem 1.5rem;
  margin: 0.5rem 0;
  gap: 1.5rem;
  background-color: ${({ theme }) => theme.colors.white};

  ${({ imagePosition }) =>
    imagePosition === 'right' &&
    css`
      flex-direction: row-reverse;
    `}
`;

export const TextBlock = styled.div`
  flex: 1;
`;

export const ImageContainer = styled.div`
  width: 466px;
  height: 429px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ImageContainerImg = styled.div`
  width: 100%;
  height: 100%;
  object-fit: cover;

  img {
    max-width: 100%;
    max-height: 100%;
  }
`;
